import Image from '../../Image';

import Logo from '../images/logo-footer.svg';
import Instagram from '../images/instagram.svg';
import Facebook from '../images/facebook.svg';
import Whasapp from '../images/whasapp.svg';
import Twitter from '../images/twitter.svg';

export default function Footer(): JSX.Element {
    const numberPhone = '56945571236';
    const socialNetworks = {
        instagram: {
            icon: Instagram,
            link: 'https://www.instagram.com/supermatchcl',
        },
        facebook: {
            icon: Facebook,
            link: 'https://www.facebook.com/SuperMatchile',
        },
        twitter: {
            icon: Twitter,
            link: '#',
        },
        whasapp: {
            icon: Whasapp,
            link: `https://wa.me/${numberPhone}?text=Quisiera%20información%20de%20SuperMatch`,
        },
    };

    return (
        <footer className="w-full bg-sm-blue-primary py-2 flex">
            <div className="container mx-auto w-full text-white flex-none md:flex content-center">
                <div className="w-full flex justify-center md:w-1/3 p-2 pt-2 md:pt-4 md:px-6 text-center md:text-left">
                    <Image src={Logo} alt="SuperMatch Logo" />
                </div>
                <div className="p-5  pt-2 md:pt-7 md:px-6 w-full md:w-1/3 text-center">
                    <div className="flex flex-col">
                        <a href="mailto:contacto@supermatch.cl">contacto@supermatch.cl</a>
                        <a className="pt-2" href="/terminos-condiciones" target="_self">
                            Ver términos y condiciones
                        </a>
                        <a className="pt-2  " href="/preguntas-frecuentes" target="_self">
                            Preguntas Frecuentes
                        </a>
                    </div>
                </div>

                {socialNetworks && (
                    <div className="p-5 md:px-6 w-full md:w-1/3">
                        <div className="flex justify-center md:justify-end content-center space-x-20 md:space-x-6 items-end cursor-pointer">
                            <a className="" href={socialNetworks.instagram.link}>
                                <Image src={socialNetworks.instagram.icon} alt="Instagram" />
                            </a>
                            <a className="" href={socialNetworks.facebook.link}>
                                <Image src={socialNetworks.facebook.icon} alt="Facebook" />
                            </a>
                        </div>
                        <a
                            className="fixed right-2 md:right-12  bottom-16 z-50 cursor-pointer animate-bounce2"
                            href={socialNetworks.whasapp.link}
                        >
                            <Image src={socialNetworks.whasapp?.icon} alt="Whasapp" height={45} width={45} />{' '}
                        </a>
                        <a
                            className="hidden md:block fixed right-6 bottom-8 pt-12 z-50 cursor-pointer animate-bounce2"
                            href={socialNetworks.whasapp.link}
                        >
                            <p className="font-extrabold text-green-200 ">Contáctanos</p>
                        </a>
                    </div>
                )}
            </div>
        </footer>
    );
}
